import { Typography, Stack, Box, Divider } from '@mui/material';
import { Settings } from '@mui/icons-material';
import { ActionMenu, capitalize, Loader, Pagination, pluralize } from '@shared';
import { SimpleListPropsType } from './SimpleList.types';
import { Card } from './SimpleList.styled';

export const SimpleList = <T extends { uuid: string }, ColumnsIds>(
  props: SimpleListPropsType<T, ColumnsIds>
) => {
  const {
    onRowClick,
    rows,
    isLoading,
    title,
    subtitle,
    entityName,
    renderElems,
    settingsItems,
    pagination,
    totalPages,
    onPageChange,
  } = props;

  return (
    <Stack>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='start'
        mb={subtitle ? 1 : 2}
      >
        <Typography variant='h4'>{title}</Typography>
        {settingsItems && settingsItems.filter((item) => !item.disabled).length > 0 && (
          <ActionMenu icon={Settings} items={settingsItems} />
        )}
      </Stack>
      {subtitle && (
        <Typography variant='subtitle1' mb={2}>
          {subtitle}
        </Typography>
      )}
      <Divider sx={{ mb: 3 }} />
      <Box>
        <Stack spacing={2} mb={2}>
          {rows.length ? (
            rows.map((row) => (
              <Card
                key={row.uuid}
                onClick={() => onRowClick && onRowClick({ [entityName]: row.uuid })}
                data-testid={`${entityName}-list-row`}
              >
                {renderElems(row)}
              </Card>
            ))
          ) : (
            <Box data-testid={`${entityName}-empty-list-row`}>
              <Typography variant='h6' sx={{ textAlign: 'center' }}>
                <i>No {pluralize(capitalize(entityName))} Found</i>
              </Typography>
            </Box>
          )}
        </Stack>
        {pagination && (
          <Stack
            sx={{
              p: 2,
              height: 60,
            }}
          >
            <Pagination totalPages={totalPages} onPageChange={onPageChange} />
          </Stack>
        )}
      </Box>
      {isLoading && <Loader />}
    </Stack>
  );
};
